
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-protection",
      function () {
        return require("private-next-pages/digital-protection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-protection"])
      });
    }
  